import Model from "../_model";

export default class ProformaInvoiceAttachmentModel extends Model {
	constructor(provider) {
		super(provider, "proforma_invoices/{proformaInvoiceId}/attachments");
	}

	_getUrl(proformaInvoiceId, { id }) {
		let url = this.apiMethod.replace("{proformaInvoiceId}", proformaInvoiceId);
		if (id) url = url.concat(`/${id}`);
		return url;
	}

	filter(proformaInvoiceId, { onSuccess, onFail }) {
		return super.filter({
			url: this._getUrl(proformaInvoiceId, {}),
			onSuccess,
			onFail,
		});
	}

	find(id, proformaInvoiceId, { onSuccess, onFail }) {
		return super.find({
			url: this._getUrl(proformaInvoiceId, { id }),
			onSuccess,
			onFail,
		});
	}

	serialize(instance) {
		return {
			file: {
				key: instance.file.key,
				type: instance.file.type,
			},
			name: instance.name,
			note: instance.note,
			accessModifier: instance.accessModifier,
		};
	}

	serializeToUpdate(instance) {
		return {
			name: instance.name,
			note: instance.note,
			accessModifier: instance.accessModifier,
		};
	}

	create(instance, proformaInvoiceId, { onSuccess, onFail }) {
		const body = this.serialize(instance);
		return super.create(body, {
			url: this._getUrl(proformaInvoiceId, {}),
			onSuccess,
			onFail,
		});
	}

	update(instance, proformaInvoiceId, { onSuccess, onFail }) {
		const body = this.serializeToUpdate(instance);
		return super.update(body, {
			url: this._getUrl(proformaInvoiceId, { id: instance.id }),
			onSuccess,
			onFail,
		});
	}

	delete(id, proformaInvoiceId, { onSuccess, onFail }) {
		return super.delete({
			url: this._getUrl(proformaInvoiceId, { id }),
			onSuccess,
			onFail,
		});
	}
}
